
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/[product]",
      function () {
        return require("private-next-pages/search/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/[product]"])
      });
    }
  